<template>
  <div>
    <ChannelSelect
      :person-id="personId"
      create-typing
      label="Nome do canal"
      @input="onSelectChannel"
    />
    <div v-if="!hasDemands && !mergeChannelId" class="channel-name__info">
      <WIcon icon="icAlertCircleOutlined" size="medium" /> Você só pode nomear
      um chat após criar uma consulta
    </div>
    <div v-if="mergeChannelId" class="channel-name__info">
      Essa conversa vai ser mesclada com o canal acima. Você não poderá ver as
      mensagens anteriores do canal, mas as pessoas do time poderão ver todas as
      mensagens.
    </div>
  </div>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'

import { ChannelSelect } from '@/components/shared/organisms'

export default {
  components: { ChannelSelect, WIcon },
  props: {
    mergeChannelId: { type: String, default: undefined },
    personId: { type: String, default: undefined },
    hasDemands: Boolean
  },
  emits: ['mergeChannel'],
  methods: {
    onSelectChannel(selectedChannel) {
      if (!selectedChannel) return

      this.$emit('mergeChannel', selectedChannel)
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.channel-name {
  &__info {
    @extend %caption;
    margin-top: var(--gl-spacing-01);
    color: var(--gl-color-shades-gray-60);
    display: flex;
    align-items: center;
    gap: var(--gl-spacing-01);
  }
}
</style>
